// DEPRECATO: Migrato al sistema di cache unificato
// Usa UnifiedDealerCache invece di questi valori
export const CACHE_KEY = 'unified_dealers';
export const CACHE_EXPIRATION = 20 * 60 * 1000; // 20 minuti

// Importa il nuovo sistema unificato
export { unifiedDealerCache } from '../../../lib/cache/UnifiedDealerCache';
export { RECOMMENDED_DEALERS_CACHE_CONFIG } from '../../../lib/recommended-dealers-cache/cacheConfig';
